module.exports = __webpack_public_path__ + "img/image92.4622f245.png";